module.exports = __webpack_public_path__ + "static/media/carousel7.418a586a.jpeg";